import React, { useEffect, useState, Fragment } from 'react'
import { Formik, Form } from 'formik'
import { Flex } from 'reflexbox'
import { useHistory } from 'react-router-dom'

import { toast } from 'react-toastify'
import * as Yup from 'yup'

import Card from 'components/Card'
import Breadcrumb from 'components/Breadcrumb'
import Button from 'components/Button'
import Loader from 'components/Loader'
import { TextField, CheckboxGroup, RadioGroup, NumberField } from 'components/Form'
import { Title } from 'components/Typography'

import { getPackages } from 'services/packages'
import { createPlanGiftCard, createValueGiftCard } from 'services/giftCards'
import { formatCurrency } from 'utils/formatters'

const BreadcrumbPath = [
  {
    label: 'Cartões presente',
    link: '/staff/prepaid-partners/gift-card',
  },
  {
    label: 'Lista de cartões',
    link: '/staff/prepaid-partners/gift-card/list',
  },
  {
    label: 'Novo cartão',
  },
]

const initialValues = {
  form_type: 'plans',
  card_name: '',
  plans: [],
  card_value: undefined,
}

const validationSchema = Yup.object().shape({
  form_type: Yup.string().required(),
  card_name: Yup.string().when('form_type', {
    is: 'plans',
    then: Yup.string().required(),
  }),
  plans: Yup.array().when('form_type', {
    is: 'plans',
    then: Yup.array().required(),
  }),
  card_value: Yup.number().when('form_type', {
    is: 'values',
    then: Yup.number()
      .min(1, 'O valor deve ser maior do que R$ 00,00')
      .required(),
  }),
})

const NewCardType = () => {
  const [packages, setPackages] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const history = useHistory()

  const handleSubmit = async ({ form_type, card_name, plans, card_value }) => {
    try {
      form_type === 'plans'
        ? await createPlanGiftCard({ description: card_name, packages: plans })
        : await createValueGiftCard({ description: formatCurrency(card_value), value: card_value })

      history.push('/staff/prepaid-partners/gift-card/list')
      toast.success('Cartão adicionado com sucesso!')
    } catch (e) {
      console.log(e)
      toast.error('Ocorreu um erro ao adicionar um novo tipo de cartão, tente novamente.')
    }
  }

  useEffect(() => {
    const getAvailablePackages = async () => {
      try {
        setIsLoading(true)

        const { data } = await getPackages({
          giftcard: true,
        })

        const formattedData = data?.map(plan => {
          return {
            label: plan?.name,
            value: `${plan?.id}`,
          }
        })

        setPackages(formattedData)
      } catch (e) {
        console.log(e)
        toast.error('Não foi possivel carregar os pacotes no momento!')
      } finally {
        setIsLoading(false)
      }
    }

    getAvailablePackages()
  }, [])

  return (
    <Flex flexDirection='column'>
      <Breadcrumb children={BreadcrumbPath} />
      <Title as='h3'>Novo cartão</Title>

      <Card flexDirection='column' mt={24}>
        {!isLoading ? (
          <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
            {({ values, isSubmitting }) => (
              <Flex as={Form} flexDirection='column' maxWidth={384}>
                <RadioGroup
                  label=''
                  mb={32}
                  direction='row'
                  name='form_type'
                  options={[
                    { label: 'Pacotes', value: 'plans' },
                    { label: 'Valor', value: 'values' },
                  ]}
                />
                {values.form_type === 'values' ? (
                  <NumberField
                    name='card_value'
                    prefix='R$ '
                    label='Valor do cartão (R$)'
                    placeholder='Valor do cartão'
                    mb={24}
                  />
                ) : (
                  <Fragment>
                    <TextField name='card_name' label='Nome do cartão' placeholder='Nome do cartão' mb={24} />
                    <CheckboxGroup name='plans' label='Selecionar pacotes de canais' options={packages} mb={24} />
                  </Fragment>
                )}
                <Flex>
                  <Button type='button' outlined mr={24} disabled={isSubmitting} onClick={() => history.goBack()}>
                    Voltar
                  </Button>
                  <Button type='submit' disabled={isSubmitting}>
                    {isSubmitting ? <Loader /> : 'Adicionar'}
                  </Button>
                </Flex>
              </Flex>
            )}
          </Formik>
        ) : (
          <Flex justifyContent='center'>
            <Loader />
          </Flex>
        )}
      </Card>
    </Flex>
  )
}

export default NewCardType
